import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 4),
    marginBottom: theme.spacing(2),
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.red_100,
    color: theme.colors.white,
    fontWeight: 600
  },
  // Let the message take the remaining width and wrap. Without minWidth: 0 a flex item
  // refuses to shrink below its content's intrinsic width — and the long, hyphenated
  // policy id forces a wide minimum that pushes the button off the banner's right edge,
  // clipping it (#32018). overflowWrap lets the policy id break if the banner gets narrow.
  message: {
    flex: 1,
    minWidth: 0,
    overflowWrap: 'anywhere'
  },
  viewButton: {
    backgroundColor: theme.colorPalette.white,
    color: theme.colorPalette.red_100,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    // Keep the button at its natural width inside the banner instead of being shrunk/clipped.
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.colorPalette.beige_25
    }
  }
});

export default makeStyles(styles);
